import http from "../../http-common";

class RatingService {
    get(id, data) {
        return http.post(`/user/getRatings/${id}`, data);
    }
}

export default new RatingService();